<form
  class="d-flex flex-wrap gap-5"
  [formGroup]="filtersForm"
>
  <base-filter-dropdown
    [items]="locations"
    filterName="location.singular"
    formControlName="location"
  ></base-filter-dropdown>
</form>
<hr *ngIf="activeFilters.length > 0" />
<div class="d-flex align-items-center flex-wrap gap-3 mb-5">
  <div
    *ngFor="let filter of activeFilters"
    class="rounded-pill bg-secondary px-4 py-2 active-filter btn-sm"
  >
    <span class="pe-1 fw-normal">
      {{ filter.filter === 'search' ? ('search.nominative' | translate) : (labels[filter.filter] | translate) }}:
    </span>
    <span>
      {{ (filter.name | translate) || (filter.value | baseFormatDate) }}
    </span>
    <i
      class="fa-solid fa-xmark ms-2 pointer"
      (click)="removeFilter(filter)"
    ></i>
  </div>
  <span
    class="pointer"
    (click)="clearFilters()"
    *ngIf="activeFilters.length"
  >
    {{ 'filter.reset' | translate }}
  </span>
</div>

<div class="max-width-500">
  <base-search
    placeholder="providers.search"
    [value]="activatedRoute.snapshot.queryParams.search"
    [useEnterEvent]="true"
    (query)="onSearchChange($event)"
  ></base-search>
</div>
